import { gql, useMutation, useQuery } from "@apollo/client";
import {
  AddIcon,
  Button,
  CrossIcon,
  IconButton,
  SideSheet,
  Spinner,
  Table,
  TextInputField,
  toaster,
} from "evergreen-ui";
import React, { useState } from "react";
import AdminGalleryRow from "src/Components/AdminGalleryRow/AdminGalleryRow";
import useInput from "src/Hooks/useInput";
import styled from "styled-components";

const Container = styled.div`
  ${(props) => props.theme.pageContainer}
`;

const Title = styled.h1`
  ${(props) => props.theme.title}
`;

export const GET_GALLERY = gql`
  {
    gallery_collection(order_by: { sequence: desc }) {
      id
      name
      sequence
      __typename
      gallery_images(order_by: { sequence: desc }) {
        id
        url
        name
        collection
        type
        created_at
        sequence
        __typename
      }
    }
  }
`;

const CREATE_GALLERY = gql`
  mutation newGallery($name: String!) {
    insert_gallery_collection_one(object: { name: $name }) {
      id
      name
      sequence
      gallery_images(order_by: { sequence: desc }) {
        id
        url
        name
        collection
        type
        created_at
        sequence
        __typename
      }
    }
  }
`;

const AdminGallery = () => {
  const { data, loading, error, refetch } = useQuery(GET_GALLERY);
  const [gallery, setGallery] = useState(false);

  const name = useInput("");
  const [newGallery, { loading: newLoading, error: newError }] = useMutation(
    CREATE_GALLERY
  );

  const createGallery = (e) => {
    e.preventDefault();
    if (!newLoading) {
      newGallery({
        variables: {
          name: name.value,
        },
      })
        .then(() => {
          toaster.success("Album created!");
          refetch();
        })
        .catch((e) => {
          toaster.danger(e.message);
        });
    }
  };
  const toggleGallery = () => {
    setGallery(!gallery);
  };

  return (
    <Container>
      <div className=" admin-page-header">
        <Title>Gallery ({data?.gallery_collection?.length})</Title>
        <div className=" admin-buttons-group">
          <Button
            iconBefore={AddIcon}
            appearance="minimal"
            onClick={toggleGallery}
          >
            New album
          </Button>
        </div>
      </div>
      <Table
        marginBottom={"1rem"}
        maxHeight={"90vh"}
        maxWidth="calc(100vw - 2rem)"
        overflow="scroll"
      >
        <Table.Head minWidth="768px" accountForScrollbar={true}>
          <Table.TextHeaderCell>Images</Table.TextHeaderCell>
          <Table.TextHeaderCell>Name</Table.TextHeaderCell>
          <Table.TextHeaderCell>Sequence</Table.TextHeaderCell>
        </Table.Head>
        {error?.message}
        {loading && (
          <div className="loading-container">
            <Spinner />{" "}
          </div>
        )}
        <Table.Body
          marginBottom={"1rem"}
          maxHeight={"90vh"}
          minWidth="768px"
          overflow="scroll"
        >
          {!loading &&
            (data?.gallery_collection?.length > 0
              ? data?.gallery_collection?.map((gal, index) => (
                  <AdminGalleryRow
                    refetch={refetch}
                    gallery={gal}
                    key={gal.id}
                  />
                ))
              : "No record found.")}
        </Table.Body>
      </Table>
      <SideSheet
        isShown={gallery}
        containerProps={{
          display: "flex",
          flex: "1",
          flexDirection: "column",
          maxWidth: "100vw",
        }}
        onCloseComplete={() => {
          setGallery(false);
        }}
      >
        <div className=" w-full p-3 bg-white flex flex-row justify-between">
          <h1 className=" font-semibold text-lg">New Album</h1>
          <IconButton icon={CrossIcon} onClick={toggleGallery} />
        </div>
        <div className=" p-3 bg-gray-100">
          <TextInputField {...name} label="Album name" />
          <Button onClick={createGallery}>Create album</Button>
          {newError?.message}
        </div>
      </SideSheet>
    </Container>
  );
};

export default AdminGallery;
